import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, Tooltip, getPaymentProcessorTitle, toast } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { cashOnDeliveryDisconnect } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/api';
import CashOnDeliveryCreateModal from 'modules/profile/payment-gateways/integrations/cash-on-delivery/components/cash-on-delivery-create-modal';
import CashOnDeliveryEditModal from 'modules/profile/payment-gateways/integrations/cash-on-delivery/components/cash-on-delivery-edit-modal';
import { CashOnDeliveryPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/types';
import { getCashOnDeliveryHelpPageLink } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon } from '@systemeio/ui/icons';
export const CashOnDelivery: FC = () => {
  const $ = _c(22);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== getConnectedPaymentIntegration) {
    t0 = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.CashOnDelivery
    });
    $[0] = getConnectedPaymentIntegration;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const cashOnDeliveryIntegration = t0;
  let t1;
  if ($[2] !== removePaymentIntegration || $[3] !== t) {
    t1 = async () => {
      await cashOnDeliveryDisconnect();
      await removePaymentIntegration({
        processor: PaymentProcessorEnum.CashOnDelivery
      });
      toast.success(t("dashboard.settings.payment-gateways.cash_on_delivery.remove_toast_notification"));
    };
    $[2] = removePaymentIntegration;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onDelete = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="whitespace-nowrap text-2xl font-bold text-black">{getPaymentProcessorTitle(PaymentProcessorEnum.CashOnDelivery)}</span>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = user?.dashboardLocale;
  let t4;
  if ($[6] !== t3) {
    t4 = getCashOnDeliveryHelpPageLink(t3);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      integration: getPaymentProcessorTitle(PaymentProcessorEnum.CashOnDelivery)
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = <TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={t5} />;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <a className="primary-link" href={t4} target="_blank" rel="noreferrer">{t6}</a>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== cashOnDeliveryIntegration || $[15] !== deleteOpened || $[16] !== onDelete || $[17] !== t) {
    t8 = cashOnDeliveryIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!cashOnDeliveryIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}<CashOnDeliveryEditModal instructions={cashOnDeliveryIntegration.details.instructions} /></div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
        payment: t("dashboard.settings.payment-gateways.cash-on-delivery-integration").toLowerCase()
      })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
        payment: t("dashboard.settings.payment-gateways.cash-on-delivery-integration").toLowerCase()
      })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.cash_on_delivery")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <CashOnDeliveryCreateModal />;
    $[14] = cashOnDeliveryIntegration;
    $[15] = deleteOpened;
    $[16] = onDelete;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <Integration logo={t2} additionalInfo={t7}>{t8}</Integration>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};